import { takeEvery, select, put, take, race } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { actionNames } from './actions'

const hasGearMode = (state) => state.webinar.isGearMode

function* streamingStartWorker() {
  const isGearMode = yield select(hasGearMode)

  if (!isGearMode) {
    return
  }

  const { initialised } = yield race({
    initialised: delay(10000),
    ignore: take(actionNames.BROADCAST_STREAMING_STOPPED),
  })

  if (initialised) {
    yield put({ type: actionNames.GEAR_MODE_PREVIEW_INITIALIZED })
  }
}

function* watchStreamingStart() {
  yield takeEvery(actionNames.BROADCAST_STREAMING_STARTED, streamingStartWorker)
}

export default [watchStreamingStart]
